<template>
  <nav class="nav">
    <ul class="nav-list">
      <li :class="{active: $route.name == 'Day'}">
        <button @click="today">
          <i class="xi-home"></i>
          <span>오늘</span>
        </button>
      </li>
      <li :class="{active: $route.name == 'Calendar'}">
        <router-link to="/calendar">
          <i class="xi-calendar"></i>
          <span>달력</span>
        </router-link>
      </li>
      <li :class="{active: $route.name == 'Setting'}">
        <router-link to="/setting">
          <i class="xi-cog"></i>
          <span>설정</span>
        </router-link>
      </li>
      <li :class="{active: $route.name == 'About'}">
        <router-link to="/about">
          <i class="xi-emoticon-smiley"></i>
          <span>소개</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Nav',
  components: {

  },
  props: [

  ],
  data() {
    return {
    };
  },
  methods: {
    today() {
      let today = '/day/' + moment(new Date()).format('YYYY-MM-DD');
      this.$router.push(today);
    }
  },
  computed: {

  },
  created() {

  },
  watch: {
    '$route' (to, from) {
    }
  }
};

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue